export interface Picked<T> {
  variant: T;
  index: number;
}

export const pickVariant = <T>(key: string, variants: T[]): Picked<T> => {
  if (variants.length <= 1) {
    return { variant: variants[0], index: 0 };
  }
  const storageKey = `adrot_${key}`;
  let current = 0;
  try {
    current = Number(localStorage.getItem(storageKey) ?? 0);
    if (!Number.isInteger(current) || current < 0) current = 0;
  } catch {
    current = 0;
  }
  const index = current % variants.length;
  try {
    localStorage.setItem(storageKey, String(index + 1));
  } catch {
    // ignore (Safari private mode, quota, etc.)
  }
  return { variant: variants[index], index };
};
